"use client";

import { useCompareStore } from "@/lib/store/compare-store";
import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Check, CopyCheck, CopyPlus } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "sonner";

type Props = {
  text: {
    ariaLabel: string;
    toCompare: string | null;
    isCompared: string | null;
    toast: {
      added: string;
      removed: string;
    };
  };
  id: string;
};

const ListingCompareButton: React.FC<Props> = ({ text, id }) => {
  const [isMounted, setisMounted] = useState(false);
  const { toggleListing, isIncluded } = useCompareStore();

  useEffect(() => {
    setisMounted(true);
  }, []);
  return (
    <Button
      aria-label={text.ariaLabel}
      aria-pressed={isIncluded(id)}
      variant={isIncluded(id) ? "default" : "outline"}
      size="sm"
      onClick={(e) => {
        e.stopPropagation();
        const res = toggleListing(id);
        toast.success(res ? text.toast.added : text.toast.removed);
      }}
    >
      {isMounted && (
        <AnimatePresence mode="popLayout" initial={false}>
          {isIncluded(id) ? (
            <motion.div
              initial={{ opacity: 0, scale: 0.5, filter: "blur(4px)" }}
              animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
              exit={{ opacity: 0, scale: 0.5, filter: "blur(4px)" }}
              className="flex items-center gap-2 justify-center w-full"
              key={`isCompared-${id}`}
            >
              <CopyCheck className="w-4 h-4" />
              {text.isCompared && <p>{text.isCompared}</p>}
            </motion.div>
          ) : (
            <motion.div
              initial={{ opacity: 0, scale: 0.7, filter: "blur(4px)" }}
              animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
              exit={{ opacity: 0, scale: 0.7, filter: "blur(4px)" }}
              className="flex flex-row gap-2 items-center justify-center w-full"
              key={`toCompare-${id}`}
            >
              <CopyPlus className="w-4 h-4" />
              {text.toCompare && <p>{text.toCompare}</p>}
            </motion.div>
          )}
        </AnimatePresence>
      )}
    </Button>
  );
};

export default ListingCompareButton;
